export default "__VITE_ASSET__Cd87H0oU__"